import StarterKit from "./StarterKit";

import Header from "./components/Header";
import HeaderMinimal from "./components/HeaderMinimal";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import Share from "./components/Share";

import HomePage from './pages/home';
import SplashScreen from './components/SplashScreen';
import BlockFloatingImages from './blocks/BlockFloatingImages';

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	HeaderMinimal.init();
	NavsFull.init();
	NavsBurger.init();
	SplashScreen.init();

	// Blocks
	BlockBanner.init();
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockMap.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();
	BlockFloatingImages.init();

	Share.init();

	// Pages
	HomePage.init();
});
